import { render, staticRenderFns } from "./SttDictionaryEdit.vue?vue&type=template&id=5b0790c0&scoped=true"
import script from "./SttDictionaryEdit.vue?vue&type=script&lang=js"
export * from "./SttDictionaryEdit.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryEdit.vue?vue&type=style&index=0&id=5b0790c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0790c0",
  null
  
)

export default component.exports